let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dc4ab")).then(() => parcelRequire('29u5J'));